import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import emplyee from './module/emplyee'
import barDetails from './module/barDetails'
import plugin from './module/plugin'
import serverLabel from './module/serverLabel'
import securityCenter from './module/securityCenter'
import rule from './module/rule'
import log from './module/log'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user,
    emplyee,
    barDetails,
    plugin,
    serverLabel,
    securityCenter,
    rule,
    log,
  },
})
